const TISS = () => import('./main.vue');

const moduleRoutes = import.meta.glob('./*/routes.js', { eager: true });

export default [
  {
    name: 'tiss',
    path: '/tiss',
    component: TISS,
    meta: {
      requiresAuth: true,
      breadcrum: 'Tiss',
      icon: 'share-square',
      can: 'list',
      on: 'tiss',
      neto: true,
    },
    children: [...Object.values(moduleRoutes).flatMap((module) => module.default)],
  },
];
